import _extends from '@babel/runtime/helpers/esm/extends';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import React__default from 'react';
import cx from 'classnames';

function withClassNames(classes, Component) {
  var _CompCasted$displayNa;

  var CompCasted = Component;

  function forwardRef(props, ref) {
    return /*#__PURE__*/React__default.createElement(CompCasted, _extends({}, props, {
      className: cx.apply(void 0, [props.className].concat(_toConsumableArray(classes))),
      ref: ref
    }));
  }

  forwardRef.displayName = "blueprinted_".concat((_CompCasted$displayNa = CompCasted === null || CompCasted === void 0 ? void 0 : CompCasted.displayName) !== null && _CompCasted$displayNa !== void 0 ? _CompCasted$displayNa : CompCasted);
  return /*#__PURE__*/React__default.forwardRef(forwardRef);
}

export { withClassNames };
//# sourceMappingURL=with-classnames.js.map
